import { InjectionToken } from '@angular/core';

export interface AnalyticsConfig {
  gtmId: string;
  enabled: boolean;
  debug: boolean;
  environment: 'development' | 'preprod' | 'production';
}

export const ANALYTICS_CONFIG = new InjectionToken<AnalyticsConfig>('analytics.config');